import { render } from "./Swipeable.vue?vue&type=template&id=413df555&scoped=true"
import script from "./Swipeable.vue?vue&type=script&lang=js"
export * from "./Swipeable.vue?vue&type=script&lang=js"

import "./Swipeable.vue?vue&type=style&index=0&id=413df555&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413df555"]])

export default __exports__